import { createFileRoute } from "@tanstack/react-router";
import { SharedItem, sharedItemHead } from "../components/SharedItem";
import { documentHeaders } from "../lib/seo";

/**
 * `/request/<code>` — the web side of a shared prayer-request link. The post
 * variant next door explains the arrangement; this one carries the stronger
 * privacy case, since a prayer request is the most personal thing anyone writes
 * in the app.
 */
export const Route = createFileRoute("/request/$id")({
  headers: documentHeaders,
  head: () => sharedItemHead("request"),
  component: () => <SharedItem kind="request" />,
});
